import { useState } from 'react';
const defaultFeedbackState = {
  message: '',
  submittedCode: '',
  success: false
};
export const useFeedback = () => {
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedback, setFeedback] = useState(defaultFeedbackState);
  const updateFeedback = _ref => {
    let {
      message,
      submittedCode,
      success
    } = _ref;
    setFeedback({
      message,
      submittedCode,
      success
    });
    setShowFeedback(true);
  };
  const resetFeedback = () => {
    setFeedback({
      message: '',
      submittedCode: '',
      success: false
    });
    setShowFeedback(false);
  };
  return {
    feedback,
    resetFeedback,
    showFeedback,
    updateFeedback
  };
};